import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Store } from '@ngrx/store';
import { ClearJointGiftingApprovalState, ClearMXMState, resetSubmitState } from '@store/actions';
import { resetAccordionState } from '@store/actions/terms-accordion/terms-accordion.actions';
import * as fromRootStore from '@store/index';

@Injectable()
export class SubmitDeactivateGuard implements CanDeactivate<unknown> {
  constructor(private globalStore: Store<fromRootStore.State>) {}

  canDeactivate(): boolean {
    this.globalStore.dispatch(resetSubmitState());
    this.globalStore.dispatch(ClearMXMState());
    this.globalStore.dispatch(ClearJointGiftingApprovalState());
    this.globalStore.dispatch(resetAccordionState());
    return true;
  }
}
